<template lang="pug">
span(v-if='isLoggedIn')
  a.navbar-brand( :href='"#/" + (key === "Dashboard" ? "" : namespace) + (key == "Dashboard" ? "home" : "/" + key)',
                  :class='{ "active": isTabActive(tab, key) }',
                  v-for='(tab, key) in tabs',
                  @click.stop='track'
                ) {{ $t(tab.alias || key) }}
    .sub-menus.alt(v-if="showSubtabs(tab, key)", :class='{"none": newMenus(key) || !tab.subtabs}')
      div(:class='{ "container-fluid": !newMenus(key) }')
        ed-tab-nav(wide v-if='newMenus(key)')
          ed-tab(v-for='(subTab, subKey) in tab.subtabs'
                :key='subKey'
                :title='subNavLabel(subKey)'
                :url='"#/" + sectionNamespace(key, subTab, subKey) + "/" + key + "/" + section(key, subTab, subKey) + "/"'
                :active='isActive(key, subTab, subKey) && $root.legacySubtab == "" || key == $root.legacySubtab'
                completed
          )
        ul.navbar-collapse(v-else)
          li
            a( :href='subTabUrl(key, subTab, subKey)',
               :class='{ "active": isActive(key, subTab, subKey) || subTab == $root.legacySubtab }',
               v-if='subKey != "label"',
               v-for='(subTab, subKey) in tab.subtabs',
               @click.stop='track'
             ) {{ subNavLabel(subKey) }}
            a(v-if='!tab.subtabs')
</template>

<script>

import Modules from '@/components/_modules'
import LegacyAuth from '@/core/legacy-auth'
import tabsJson from '@/core/site-map/map.json'
import Intercom from '@/components/intercom'

const { allowedModules } = LegacyAuth

export default {
  name: 'site-map',

  props: {
    reference: null,
    className: { type: Object, default: () => ({ value: '' }) }
  },

  created() {
    this.allowedModules = allowedModules.get
  },

  computed: {
    isLoggedIn() {
      return global.config ? true : this.$store.state.isLoggedIn
    },

    // application namespace
    namespace() {
      return global.config.namespace || 'd'// this.$router.currentRoute.params.namespace
    },

    tabs() {
      return this.sitemap || (this.namespace !== 'd' ? this.namespace === '404' ? this.allowedModules : this.allowedModules/* Modules */ : this.allowedModules)
    }
  },

  methods: {
    isTabActive(tab, key) { return (key === this.$route.params.page && this.$root.legacyTab === '' || tab.label === this.$root.legacyTab) },

    showSubtabs(tab, key) {
      const isActive = this.isTabActive(tab, key)
      if (isActive) {
        !tab.autoHideSubtabs || (tab.subtabs.length > 1)
          ? this.className.value = ''
          : this.className.value = 'no-tabs'
      }
      return (!tab.autoHideSubtabs || (tab.subtabs.length > 1)) && isActive
    },

    track(e) {
      const page = e.target.firstChild.textContent
      const event = `visited_${page}`
      Intercom.track(event)
    }
  },

  data() {
    return {
      sitemap: global.config.namespace && global.config.sitemap && global.config.sitemap[global.config.namespace],

      section(tab, subTab, subKey) {
        // if (Modules[tab].notImplemented) return subTab
        const url = tabsJson[tab]
          ? tabsJson[tab].pack && ((tabsJson[tab].pack[subTab] || {}).name || tabsJson[tab].pack[subTab]) ||
          this.tabs[tab].subtabs && this.tabs[tab].subtabs[subKey]
          : ''

        if (this.tabs[tab].subtabs && global.config.namespace) {
          return subKey
        }

        return (url.label || url).replace('*', '').replace('#', '')
      },

      isActive(tab, subTab, subKey) {
        let url = tabsJson[tab]
          ? tabsJson[tab].pack && (
                      // Modules[tab].notImplemented
                      // ? subTab
                      /* : */((tabsJson[tab].pack[subTab] || {}).name || tabsJson[tab].pack[subTab])
          ) ||
          this.tabs[tab].subtabs && this.tabs[tab].subtabs[subKey]
          : ''

        url = (url.label || '').replace('#', '') || url
        const currentRoute = this.$route.params.section + (this.$route.params.action ? '/' + this.$route.params.action : '')

        // if (this.tabs[tab].label === this.$root.legacyTab) return true
        // if (subTab === this.$root.legacySubtab) return true
        if (this.$root.legacySubtab === this.subNavLabel(subKey)) return true

        if (this.reference && this.reference === tab + '/' + url) {
          global.app.backReferenceTitle = this.subNavLabel(subKey)
          return true
        }

        if (this.tabs[tab].subtabs && global.config.namespace) {
          return this.$route.params.section === subKey
        }

        // Admin tabs
        const COMPANY_SETTINGS_CARDS =
          this.$route.params.page === 'Admin' &&
          this.$route.params.section !== 'Settings' &&
          this.$route.params.section !== 'GeneralSettings' &&
          this.$route.query['back-to']

        if (COMPANY_SETTINGS_CARDS) {
          return adminSubtabs()
        }

        if (~url.indexOf('#/d')) {
          return ~window.location.hash.indexOf(url)
        } else {
          if (currentRoute.includes(url) && currentRoute !== url) {
            return true
          } else {
            return !this.$root.legacySubtab && url === currentRoute || ~window.location.hash.indexOf(url)
          }
        }

        function adminSubtabs() {
          return subTab === 'Settings'
        }
      },

      sectionNamespace(tab, subTab, subKey) {
        if (global.config.namespace) return global.config.namespace

        if (
          tabsJson[tab].pack && tabsJson[tab].pack[subTab] && tabsJson[tab].pack[subTab].name.indexOf('>') === 0 ||
          tabsJson[tab].pack && tabsJson[tab].pack[subTab] && tabsJson[tab].pack[subTab].name.indexOf('#') === 0 ||
          tabsJson[tab].subtabs && tabsJson[tab].subtabs[subKey] && tabsJson[tab].subtabs[subKey].indexOf('#') === 0 ||
          (subTab.label || subTab).indexOf('#') === 0
        ) {
          return 'd'
        }

        return Modules[tab] && !Modules[tab].entry && !Modules[tab].notImplemented ||
          Modules[tab + '/' + this.section(tab, subTab, subKey)] ||
          tabsJson[tab].subtabs && tabsJson[tab].subtabs[subTab]
          ? 'd'
          : 'i'
      },

      subTabUrl: (key, subTab, subKey) => {
        let url = ''
        let section = this.section(key, subTab, subKey)
        section = section.label || section

        if (~section.indexOf('#/d')) {
          url = `${section}/`
        } else {
          url = `#/${this.sectionNamespace(key, subTab, subKey)}/${key}/${section}/`
        }

        return url
      },

      subNavLabel(key) {
        return this.$t(key.replace(/-/g, ' '))
      },

      newMenus(tab) {
        return false
        // return Modules[tab] && Modules[tab].notImplemented && !Modules[tab].pack
      }
    }
  }
}

</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

.navbar-brand.logo {
  margin-top: -5px;
}
.navbar-primary {
  @include theme {
    border-bottom: 2px solid v(background-light);
  }
  @include theme(true) {
    border-bottom: 4px solid lighten(v(primary-04), 5%);
  }
}

.navbar-primary a {
  text-transform: capitalize;
}
.theme.skin .navbar-primary .sub-menus.none {
  background-color: $canvas;
  padding-bottom: 0.6rem;
  border-top: 3px solid $background-light;
}
.theme.skin .navbar-primary .navbar-brand:not(.active) .sub-menus > div {
  display: none;
}

.navbar-primary .sub-menus.alt {
  @include theme {
  background-color: v(canvas);
  border-top: 2px solid v(background-light);
  border-bottom: 1px solid v(background-light);
  }

  li > a {
    text-transform: none;
    font-size: $font-size-base;
    line-height: 2.3rem;
    vertical-align: bottom;
    margin-right: 15px;

    @include theme {
    //border-bottom: .1rem solid v(border);
    }
    border-bottom: .2rem dashed transparent;

    &.active, &.active:hover {
      cursor: default;
    }
    &:hover {
      cursor: pointer;
    }
    &.active, &:hover {
      @include theme {
      color: v(primary-04);
      border-bottom: .2rem solid v(tertiary-01);
      }
      //line-height: 2rem;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/core/site-map/index.vue